<!-- ALERT & CONFIRM DIALOG -->
<p-toast></p-toast>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN CONTAINER -->
<div class="card" *ngIf="this.translations != null">

    <!-- TOOLBAR -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">

            <!-- BACK BUTTON -->
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>

            <!-- SAVE BUTTON -->
            <button pButton pRipple icon="pi pi-save" class="p-button-success p-mr-2"
                [pTooltip]="translations.lbl_or + ' ' + translations.lbl_update + ' ' + translations.lbl_documents"
                (click)="displayModalConfirmation=true"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">

        <!-- CREATE FORM -->
        <div class="p-col-12 p-md-6">
            <p-panel [header]="translations.lbl_detail + ' ' + translations.lbl_coordination">
                <div class="p-fluid">
                    <ng-container *ngTemplateOutlet="infoTemplateCreate"></ng-container>
                </div>
            </p-panel>
        </div>
    </div>

    <ng-template #infoTemplateCreate [formGroup]="globalUserDataFormParams">
        <!-- GUIDE INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_guide }}</span>
            <ng-container *ngIf="globalUserDataFormParams.get('selectedGuide').value != null; else noSelectionGuide">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedGuide').value || " " }}</span>
            </ng-container>

            <ng-template #noSelectionGuide>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_guide}}</span>
            </ng-template>
        </div>

        <!-- COORDINATION INFO -->
        <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
            <span>{{ translations.lbl_coordination }}</span>
            <ng-container
                *ngIf="globalUserDataFormParams.get('selectedCoordination').value != null; else noSelectionCoordination">
                <span class="p-text-bold">
                    {{ globalUserDataFormParams.get('selectedCoordination').value || " " }}</span>
            </ng-container>

            <ng-template #noSelectionCoordination>
                <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_coordination }}</span>
            </ng-template>
        </div>
    </ng-template>

    <!-- FORM TRANSFER -->
    <div class="card">

        <!-- TABLE -->
        <p-table #dt1 [value]="globalUserDataFormParams.get('selectedListExternGuides').value" [columns]="lstCols"
            *ngIf="globalUserDataFormParams.get('selectedListExternGuides').value != null" selectionMode="single"
            dataKey="externGuide.id" [rows]="5" [paginator]="true" [rowsPerPageOptions]="[5, 10, 20]"
            [globalFilterFields]="['externGuide.storeId','externGuide.guideId','externGuide.guideName','externGuide.email','externGuide.mobilePhone','externGuide.nationality']"
            [rowHover]="true"
            currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
            [showCurrentPageReport]="true" responsive="true" editMode="row" [expandedRowKeys]="expandedRows">

            <!-- CAPTION -->
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <h5 class="p-m-0">
                        {{ (translations.lbl_administration + ' ' + translations.lbl_for + ' ' +
                        translations.lbl_extern + ' ' + translations.lbl_guides ) | uppercase }}
                    </h5>


                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                            placeholder="{{translations.lbl_search}}..." />
                    </span>
                </div>

                <span class="p-input-icon-left">

                    <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-mr-2 z-5"
                        (click)="reloadGetListExternGuideDocuments()"></button>
                </span>
            </ng-template>

            <!-- HEADER -->
            <ng-template pTemplate="header">
                <tr>

                    <th colspan="2" pSortableColumn="externGuide.storeId" pTooltip="{{ translations.lbl_storeId }}">
                        {{ translations.lbl_storeId }} <p-sortIcon field="externGuide.storeId"></p-sortIcon>
                    </th>

                    <th colspan="2" pSortableColumn="externGuide.guideId" pTooltip="{{ translations.lbl_guideId }}">
                        {{ translations.lbl_guideId }} <p-sortIcon field="externGuide.guideId"></p-sortIcon>
                    </th>

                    <th pSortableColumn="externGuide.guideName" pTooltip="{{ translations.lbl_name }}">
                        {{ translations.lbl_name }} <p-sortIcon field="externGuide.guideName"></p-sortIcon>
                    </th>

                    <th pSortableColumn="externGuide.email" pTooltip="{{ translations.lbl_email }}">
                        {{ translations.lbl_email }} <p-sortIcon field="externGuide.email"></p-sortIcon>
                    </th>

                    <th pSortableColumn="externGuide.mobilePhone" pTooltip="{{ translations.lbl_cell_phone }}">
                        {{ translations.lbl_cell_phone }} <p-sortIcon field="externGuide.mobilePhone"></p-sortIcon>
                    </th>
                    <th pSortableColumn="externGuide.nationality" pTooltip="{{ translations.lbl_nationality }}">
                        {{ translations.lbl_nationality }} <p-sortIcon field="externGuide.nationality"></p-sortIcon>
                    </th>

                    <th pTooltip="{{ translations.lbl_options }}">
                        {{ translations.lbl_options }}
                    </th>
                </tr>
            </ng-template>

            <!-- BODY -->
            <ng-template pTemplate="body" let-data let-editing="editing" let-ri="rowIndex">
                <tr [pSelectableRow]="data" [pEditableRow]="data" [formGroup]="globalUserDataFormParams">


                    <td colspan="2"
                        pTooltip="{{ data.externGuide?.storeId || (translations.lbl_without + ' ' + translations.lbl_storeId) }}">
                        {{ data.externGuide?.storeId || (translations.lbl_without + ' ' + translations.lbl_storeId) }}
                    </td>

                    <td colspan="2"
                        pTooltip="{{ data.externGuide?.guideId || (translations.lbl_without + ' ' + translations.lbl_guideId) }}">
                        {{ data.externGuide?.guideId || (translations.lbl_without + ' ' + translations.lbl_guideId) }}
                    </td>

                    <td
                        pTooltip="{{ data.externGuide?.guideName || (translations.lbl_without + ' ' + translations.lbl_name) }}">
                        {{ data.externGuide?.guideName || (translations.lbl_without + ' ' + translations.lbl_name) }}
                    </td>

                    <td
                        pTooltip="{{ data.externGuide?.email || (translations.lbl_without + ' ' + translations.lbl_email) }}">
                        {{ data.externGuide?.email || (translations.lbl_without + ' ' + translations.lbl_email) }}
                    </td>

                    <td
                        pTooltip="{{ data.externGuide?.mobilePhone || (translations.lbl_without + ' ' + translations.lbl_cell_phone) }}">
                        {{ data.externGuide?.mobilePhone || (translations.lbl_without + ' ' +
                        translations.lbl_cell_phone) }}
                    </td>

                    <td
                        pTooltip="{{ data.externGuide?.nationality || (translations.lbl_without + ' ' + translations.lbl_nationality) }}">
                        {{ data.externGuide?.nationality || (translations.lbl_without + ' ' +
                        translations.lbl_nationality) }}
                    </td>


                    <td>
                        <!-- EDIT BUTTON -->
                        <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                            *ngIf="!editing" (click)="onRowEditInit(data)"></button>

                        <!-- CANCEL BUTTON -->
                        <button pButton pRipple pCancelEditableRow type="button" icon="pi pi-times"
                            class="p-button-rounded p-button-danger p-mr-2" *ngIf="editing"
                            (click)="onRowEditCancel(data, ri)"></button>

                        <!-- DELETE BUTTON -->
                        <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-mr-2"
                            (click)="deletePropertyDocument(data)" pTooltip="{{translations.lbl_delete}}"></button>
                    </td>
                </tr>

                <!-- SUB TABLE -->
                <tr>
                    <td colspan="3"></td>
                    <td colspan="5" class="sub-table-container">
                        <table class="small-table" responsive="true" [formGroup]="globalUserDataFormParams">
                            <!-- HEADER SUB TABLE-->
                            <thead>
                                <tr>
                                    <th pTooltip="{{ translations?.lbl_storeId }}"
                                        data-label="{{ translations?.lbl_storeId }}">{{
                                        translations.lbl_storeId }}</th>

                                    <th pTooltip="{{ translations.lbl_description }}"
                                        data-label="{{ translations.lbl_description }}">{{
                                        translations.lbl_description }}</th>

                                    <th pTooltip="{{ translations.lbl_short_Name }}"
                                        data-label="{{ translations.lbl_short_Name }}">{{
                                        translations.lbl_short_Name }}</th>

                                    <th pTooltip="{{ translations.lbl_status }}"
                                        data-label="{{ translations.lbl_status }}">{{ translations.lbl_status }}
                                    </th>

                                    <th pTooltip="{{ translations.lbl_country }}"
                                        data-label="{{ translations.lbl_country }}">{{ translations.lbl_country }}
                                    </th>
                                </tr>
                            </thead>

                            <!-- BODY SUB TABLE -->
                            <tbody>
                                <ng-container *ngIf="data.store?.length > 0; else emptyMessage">
                                    <tr *ngFor="let store of data.store" class="p-mb-4">
                                        <!-- ID -->
                                        <td class="align-end" pTooltip="{{ store.storeId || '-' }}"
                                            [attr.data-label]="translations?.lbl_storeId">
                                            {{ store.storeId || '-' }}
                                        </td>

                                        <!-- Description -->
                                        <td class="align-end" pTooltip="{{ store.descri || '-' }}"
                                            [attr.data-label]="translations?.lbl_description">
                                            {{ store.descri || '-' }}
                                        </td>

                                        <!-- Short Name -->
                                        <td class="align-end" pTooltip="{{ store.shrName || '-' }}"
                                            [attr.data-label]="translations?.lbl_short_Name">
                                            {{ store.shrName || '-' }}
                                        </td>

                                        <!-- Status -->
                                        <td class="align-end" pTooltip="{{ store.status || '-' }}"
                                            [attr.data-label]="translations?.lbl_status">
                                            {{ store.status || '-' }}
                                        </td>

                                        <!-- CountryId -->
                                        <td class="align-end" pTooltip="{{ store.countryId || '-' }}"
                                            [attr.data-label]="translations?.lbl_countryId">
                                            {{ store.countryId || '-' }}
                                        </td>
                                    </tr>
                                </ng-container>

                                <!-- EMPTY MESSAGE -->
                                <ng-template #emptyMessage>
                                    <tr>
                                        <td colspan="6" class="text-center">
                                            {{ translations?.lbl_no_records_found }}
                                        </td>
                                    </tr>
                                </ng-template>
                            </tbody>

                        </table>
                    </td>
                </tr>
            </ng-template>

            <!-- EMPTY -->
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns ? columns.length : 1">
                        {{translations.lbl_no_records_found}}
                    </td>
                </tr>
            </ng-template>

            <!-- SUMMARY -->
            <ng-template pTemplate="summary">
                <div class="p-d-flex">
                    <span class="p-mr-2">{{ translations.lbl_total }}</span>
                    <span class="p-text-bold p-mr-2">
                        {{ (globalUserDataFormParams.get('selectedListExternGuides').value).length || 0 }}
                    </span>
                    <span>{{ translations.lbl_records }}</span>
                </div>
            </ng-template>

        </p-table>
    </div>
</div>




<!-- CONFIRMATION DIALOG -->
<p-dialog [modal]="true" [closable]="true" (onHide)="onRowEditCancel()"
    [header]="translations.lbl_save + ' ' + translations.lbl_or + ' ' + translations.lbl_update + ' ' + translations.lbl_extern+ ' ' + translations.lbl_guides"
    [(visible)]="displayModalConfirmation" styleClass="p-fluid" [modal]="true" [style]="{width: '50vw'}"
    [maximizable]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false">

    <div class="card">

        <!-- MAIN CONTENT -->
        <div class="p-grid">
            <div class="p-col-12 p-md-12">
                <div class="p-fluid">
                    <ng-container *ngTemplateOutlet="infoTemplateCreate"></ng-container>
                </div>
            </div>
        </div>

        <ng-template #infoTemplateCreate [formGroup]="globalUserDataFormParams">

            <!-- GUIDE INFO -->
            <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
                <span>{{ translations.lbl_guide }}</span>
                <ng-container
                    *ngIf="globalUserDataFormParams.get('selectedGuide').value != null; else noSelectionGuide">
                    <span class="p-text-bold">
                        {{ globalUserDataFormParams.get('selectedGuide').value || " " }}</span>
                </ng-container>

                <ng-template #noSelectionGuide>
                    <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_guide}}</span>
                </ng-template>
            </div>

            <!-- COORDINATION INFO -->
            <div class="subTitle p-d-flex p-ai-center p-jc-between p-py-2">
                <span>{{ translations.lbl_coordination }}</span>
                <ng-container
                    *ngIf="globalUserDataFormParams.get('selectedCoordination').value != null; else noSelectionCoordination">
                    <span class="p-text-bold">
                        {{ globalUserDataFormParams.get('selectedCoordination').value || " " }}</span>
                </ng-container>

                <ng-template #noSelectionCoordination>
                    <span class="p-text-bold">{{ translations.lbl_without + ' ' + translations.lbl_coordination
                        }}</span>
                </ng-template>
            </div>

            <!-- SEPARADOR -->
            <p-divider></p-divider>

            <p-steps class="p-mb-4 steps-navegacion" [model]="items" [(activeIndex)]="activeIndex"
                [readonly]="false"></p-steps>

            <!-- Contenido de cada paso, pero solo se muestra el que corresponde a activeIndex -->
            <div *ngIf="activeIndex === 0" id="step-0" class="step-content">
                <div class="p-grid">

                    <!-- STORE ID -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <!-- ID INPUT -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_storeId }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedStoreId').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionStoreID">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedStoreId" formControlName="selectedStoreId"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionStoreID>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.storeId
                                    || translations.lbl_without + ' ' + translations.lbl_storeId
                                    }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- GUIDE ID -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_guideId }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedGuideId').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionGuideId">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedGuideId" formControlName="selectedGuideId"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionGuideId>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.guideId
                                    || translations.lbl_without + ' ' + translations.lbl_guideId }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- BIRTH YEAR -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_birth_year }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedBirthYear').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionBirthYear">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedBirthYear" formControlName="selectedBirthYear"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="4"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionBirthYear>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.birthYear
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_birth_year }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- BIRTH MONTH -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_birth_month }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedBirthMonth').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionBirthMonth">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedBirthMonth" formControlName="selectedBirthMonth"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="2"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionBirthMonth>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.birthMonth
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_birth_month }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- BIRTH DAY -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_birth_day }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedBirthDay').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionBirthDay">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedBirthDay" formControlName="selectedBirthDay"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="2"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionBirthDay>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.birthDay
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_birth_day }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- BIRTH SYSTEM ID -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_system_id }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedSystemId').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionSystemId">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedSystemId" formControlName="selectedSystemId"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionSystemId>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.systemId
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_id }}</span>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="activeIndex === 1" id="step-1" class="step-content">
                <div class="p-grid">
                    <!-- GUIDE NAME -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_guide_name }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedGuideName').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionGuideName">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedGuideName" formControlName="selectedGuideName"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionGuideName>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.guideName
                                    || translations.lbl_without + ' ' + translations.lbl_name }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- LAST NAME -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_last_name }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedLastName').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionLastName">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedLastName" formControlName="selectedLastName"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionLastName>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.lastName
                                    || translations.lbl_without + ' ' + translations.lbl_last_name }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- EMAIL -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_email }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedEmail').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <div class="p-col-12 p-md-8">
                                <input id="selectedEmail" formControlName="selectedEmail"
                                    placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                    pInputText>
                            </div>
                            <!-- SE EDITA SE RETIRA TEMPLATE EMPTY -->
                            <!-- <ng-template #noSelectionEmail>
                    <span class="p-text-bold ellipsis">{{
                        globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.email ||
                        translations.lbl_without + ' ' + translations.lbl_email }}</span>
                </ng-template> -->
                        </div>
                    </div>

                    <!-- MOBILE PHONE -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_mobile_phone }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedMobilePhone').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <div class="p-col-12 p-md-8">
                                <input id="selectedMobilePhone" formControlName="selectedMobilePhone"
                                    placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                    pInputText>
                            </div>

                            <!-- SE EDITA SE RETIRA TEMPLATE EMPTY -->
                            <!-- <ng-template #noSelectionMobilePhone>
                    <span class="p-text-bold ellipsis">{{
                        globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.mobilePhone
                        ||
                        translations.lbl_without + ' ' + translations.lbl_mobilePhone }}</span>
                </ng-template> -->
                        </div>
                    </div>

                    <!-- OTHER PHONE -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_other_phone }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedOtherPhone').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input id="selectedOtherPhone" formControlName="selectedOtherPhone"
                                    placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                    pInputText>
                            </div>
                            <!-- <ng-container
                    *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionOtherPhone">
                    <div class="p-col-12 p-md-8">
                        <input id="selectedOtherPhone" formControlName="selectedOtherPhone"
                            placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                            pInputText>
                    </div>
                </ng-container>

                <ng-template #noSelectionOtherPhone>
                    <span class="p-text-bold ellipsis">{{
                        globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.otherPhone
                        ||
                        translations.lbl_without + ' ' + translations.lbl_otherPhone }}</span>
                </ng-template> -->
                        </div>
                    </div>

                    <!-- STATUS GUIDE -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_status_guide }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedStatusGuide').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionStatusGuide">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedStatusGuide" formControlName="selectedStatusGuide"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionStatusGuide>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.statusGuide
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_status }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- GUI TYPE -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_guide_type }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedGuideType').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionGuideType">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedGuideType" formControlName="selectedGuideType"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionGuideType>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.guideType
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_guideType }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- MALE FEMALE -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_male_female }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedMaleFemale').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionMaleFemale">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedMaleFemale" formControlName="selectedMaleFemale"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionMaleFemale>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.maleFemale
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_maleFemale }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- CURRENT JOB -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_current_job }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedCurrentJob').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input id="selectedCurrentJob" formControlName="selectedCurrentJob"
                                    placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                    pInputText>
                            </div>
                            <!-- 
                <ng-container
                    *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionCurrentJob">
                    <div class="p-col-12 p-md-8">
                        <input id="selectedCurrentJob" formControlName="selectedCurrentJob"
                            placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                            pInputText>
                    </div>
                </ng-container>

                <ng-template #noSelectionCurrentJob>
                    <span class="p-text-bold ellipsis">{{
                        globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.currentJob
                        ||
                        translations.lbl_without + ' ' + translations.lbl_currentJob }}</span>
                </ng-template> -->
                        </div>
                    </div>

                    <!-- SPOKEN LANGUAGE -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_spoken_language }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedSpokenLanguage').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input id="selectedSpokenLanguage" formControlName="selectedSpokenLanguage"
                                    placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                    pInputText>
                            </div>
                            <!-- <ng-container
                    *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionSpokenLanguage">
                    <div class="p-col-12 p-md-8">
                        <input id="selectedSpokenLanguage" formControlName="selectedSpokenLanguage"
                            placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                            pInputText>
                    </div>
                </ng-container>

                <ng-template #noSelectionSpokenLanguage>
                    <span class="p-text-bold ellipsis">{{
                        globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.spokenlanguage
                        ||
                        translations.lbl_without + ' ' + translations.lbl_spokenLanguage }}</span>
                </ng-template> -->
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="activeIndex === 2" id="step-2" class="step-content">
                <div class="p-grid">

                    <!-- NATIONALITY -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_nationality }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedNationality').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionNationality">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedNationality" formControlName="selectedNationality"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionNationality>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.nationality
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_nationality }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- REIDEN COUNTRY -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_resident_country }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedResidenCountry').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionResidenCountry">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedResidenCountry" formControlName="selectedResidenCountry"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionResidenCountry>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.residenCountry
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_residenCountry }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- ZONE -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_zone }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedZone').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionZone">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedZone" formControlName="selectedZone"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionZone>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.zone
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_zone }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- NATIONAL -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_national }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedNational').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionNational">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedNational" formControlName="selectedNational"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionNational>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.national
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_national }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- LOCAL -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_local }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedLocal').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionLocal">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedLocal" formControlName="selectedLocal"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionLocal>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.local
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_local }}</span>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="activeIndex === 3" id="step-3" class="step-content">
                <div class="p-grid">
                    <!-- LOCAL COUNTRY -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_local_country }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedLocalCountry').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionLocalCountry">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedLocalCountry" formControlName="selectedLocalCountry"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionLocalCountry>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.localCountry
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_localCountry }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- LOCAL STATE -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_local_state }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedLocalState').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionLocalState">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedLocalState" formControlName="selectedLocalState"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionLocalState>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.localState
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_localState }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- LOCAL CITY -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_local_city }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedLocalCity').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionLocalCity">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedLocalCity" formControlName="selectedLocalCity"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionLocalCity>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.localCity
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_localCity }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- COUNTRY ADDRESS -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_country_address }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedCountryAddress').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input id="selectedCountryAddress" formControlName="selectedCountryAddress"
                                    placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                    pInputText>
                            </div>
                            <!-- <ng-container
                    *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionCountryAddress">
                    <div class="p-col-12 p-md-8">
                        <input id="selectedCountryAddress" formControlName="selectedCountryAddress"
                            placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                            pInputText>
                    </div>
                </ng-container>

                <ng-template #noSelectionCountryAddress>
                    <span class="p-text-bold ellipsis">{{
                        globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.countryAddress
                        ||
                        translations.lbl_without + ' ' + translations.lbl_countryAddress }}</span>
                </ng-template> -->
                        </div>
                    </div>

                    <!-- STATE ADDRESS -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_state_address }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedStateAddress').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input id="selectedStateAddress" formControlName="selectedStateAddress"
                                    placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                    pInputText>
                            </div>
                            <!-- <ng-container
                    *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionStateAddress">
                    <div class="p-col-12 p-md-8">
                        <input id="selectedStateAddress" formControlName="selectedStateAddress"
                            placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                            pInputText>
                    </div>
                </ng-container>

                <ng-template #noSelectionStateAddress>
                    <span class="p-text-bold ellipsis">{{
                        globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.stateAddress
                        ||
                        translations.lbl_without + ' ' + translations.lbl_stateAddress }}</span>
                </ng-template> -->
                        </div>
                    </div>

                    <!-- CITY ADRRESS -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_city_address }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedCityAddress').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input id="selectedCityAddress" formControlName="selectedCityAddress"
                                    placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                    pInputText>
                            </div>
                            <!-- <ng-container
                    *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionCityAddress">
                    <div class="p-col-12 p-md-8">
                        <input id="selectedCityAddress" formControlName="selectedCityAddress"
                            placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                            pInputText>
                    </div>
                </ng-container>

                <ng-template #noSelectionCityAddress>
                    <span class="p-text-bold ellipsis">{{
                        globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.cityAddress
                        ||
                        translations.lbl_without + ' ' + translations.lbl_cityAddress }}</span>
                </ng-template> -->
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="activeIndex === 4" id="step-4" class="step-content">
                <div class="p-grid">

                    <!-- CURRENT ROLE -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_current_role }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedCurrentRole').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input id="selectedCurrentRole" formControlName="selectedCurrentRole"
                                    placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                    pInputText>
                            </div>
                            <!-- <ng-container
                    *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionCurrentRole">
                    <div class="p-col-12 p-md-8">
                        <input id="selectedCurrentRole" formControlName="selectedCurrentRole"
                            placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                            pInputText>
                    </div>
                </ng-container>

                <ng-template #noSelectionCurrentRole>
                    <span class="p-text-bold ellipsis">{{
                        globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.currentRole
                        ||
                        translations.lbl_without + ' ' + translations.lbl_currentRole }}</span>
                </ng-template> -->
                        </div>
                    </div>

                    <!-- CURRENT LEVEL -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_current_level }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedCurrentLevel').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionCurrentLevel">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedCurrentLevel" formControlName="selectedCurrentLevel"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionCurrentLevel>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.currentLevel
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_currentLevel }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- ZONE EXPERIENCE -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_zone_experience }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedZoneExperience').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionZoneExperience">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedZoneExperience" formControlName="selectedZoneExperience"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionZoneExperience>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.zoneExperience
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_zoneExperience }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- NATIO EXPERIENCE -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_natio_experience }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedNatioExperience').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionNatioExperience">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedNatioExperience" formControlName="selectedNatioExperience"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionNatioExperience>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.natioExperience
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_natioExperience }}</span>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="activeIndex === 5" id="step-5" class="step-content">
                <div class="p-grid">
                    <!-- SENDING YEAR -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_sending_year }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedSendingYear').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionSendingYear">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedSendingYear" formControlName="selectedSendingYear"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionSendingYear>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.sendingYear
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_sendingYear }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- SENDING MONTH -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_sending_month }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedSendingMonth').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionSendingMonth">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedSendingMonth" formControlName="selectedSendingMonth"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionSendingMonth>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.sendingMonth
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_sendingMonth }}</span>
                            </ng-template>
                        </div>
                    </div>

                    <!-- SENDING DAY -->
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-formgrid p-grid p-ai-center p-jc-between">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_sending_day }}<span
                                        *ngIf="globalUserDataFormParams.get('selectedSendingDay').value == null"
                                        style="color:red">
                                        (*)</span></span>
                            </div>

                            <ng-container
                                *ngIf="globalUserDataFormParams.get('selectedUpdatedExternGuides').value == null; else noSelectionSendingDay">
                                <div class="p-col-12 p-md-8">
                                    <input id="selectedSendingDay" formControlName="selectedSendingDay"
                                        placeholder="Solo alfanumericos (letras y numeros)" type="text" maxlength="50"
                                        pInputText>
                                </div>
                            </ng-container>

                            <ng-template #noSelectionSendingDay>
                                <span class="p-text-bold ellipsis">{{
                                    globalUserDataFormParams.get('selectedUpdatedExternGuides').value?.externGuide?.sendingDay
                                    ||
                                    translations.lbl_without + ' ' + translations.lbl_sendingDay }}</span>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Botones para navegar entre pasos -->
            <div class="p-d-flex p-jc-between p-mt-4 botones-navegacion">
                <button pButton label="Anterior" (click)="setStep(activeIndex - 1)"
                    [disabled]="activeIndex === 0"></button>
                <button pButton label="Siguiente" (click)="setStep(activeIndex + 1)"
                    [disabled]="activeIndex === items.length - 1"></button>
            </div>

        </ng-template>

    </div>


    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="displayModalConfirmation=false"></button>

        <button pButton pRipple type="button" icon="pi pi-check" [disabled]="activeIndex != 5"
            label="{{translations.lbl_save + ' / ' + translations.lbl_update}}" class="p-button-raised p-button-success"
            (click)="createUpdatePropertyDocument()"></button>
    </ng-template>
</p-dialog>